import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiMapPin, FiPhone, FiMail } = FiIcons;

const Contact = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12 text-center">
          <h1 className="text-3xl font-bold text-slate-900 mb-4">Contact Us</h1>
          <p className="text-slate-600 mb-10">We'd love to hear from you. Reach out to inquire about bed-space availability.</p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex flex-col items-center p-6 bg-slate-50 rounded-xl">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4">
                <SafeIcon icon={FiMapPin} className="w-5 h-5" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2">Location</h3>
              <p className="text-sm text-slate-600">Mira Monte Subdivision, Lucban, Quezon 4328</p>
            </div>
            
            <div className="flex flex-col items-center p-6 bg-slate-50 rounded-xl">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4">
                <SafeIcon icon={FiPhone} className="w-5 h-5" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2">Phone</h3>
              <p className="text-sm text-slate-600">(042) 123-4567</p>
            </div>
            
            <div className="flex flex-col items-center p-6 bg-slate-50 rounded-xl">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4">
                <SafeIcon icon={FiMail} className="w-5 h-5" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2">Email</h3>
              <p className="text-sm text-slate-600">hello@cloudsboardinghouse.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;